import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class FormButton extends Component {
  static propTypes = {
    onPreviousStep: PropTypes.func,
    onSaveAsDraft: PropTypes.func,
    onReset: PropTypes.func,
    previousStep: PropTypes.any,
    nextStep: PropTypes.any,
    currentStep: PropTypes.any,
    submitStatus: PropTypes.oneOf(['ready', 'busy', 'failed', 'success']),
    formInvalid: PropTypes.bool,
    submitText: PropTypes.string,
    onSubmit: PropTypes.func,
    submitClassName: PropTypes.string,
  }

  static defaultProps = {
    className: 'margin-top-m',
    submitStatus: 'ready',
    submitClassName: 'button-primary',
    formInvalid: false,
  }

  getSubmitLabel() {
    switch (this.props.submitStatus) {
      case 'ready':
        return (
          this.props.submitText ||
          (this.props.currentStep && this.props.currentStep.submitText) ||
          (this.props.nextStep ? 'Next' : 'Submit')
        )
      case 'busy':
        return 'Please wait...'
      case 'failed':
        return 'Check your details'
      case 'success':
        return 'Saved'
    }
  }

  render() {
    const { className, submitClassName, nextStep, submitStatus, formInvalid, onSubmit } = this.props
    const busy = submitStatus == 'busy'
    const submitLabel = this.getSubmitLabel()
    return (
      <div className={className}>
        <button
          type="button"
          className={classnames([
            'button',
            submitClassName,
            {
              'in-progress': busy,
              success: submitStatus == 'success',
              complete: submitStatus == 'success',
              error: submitStatus == 'failed',
            },
          ])}
          disabled={busy || (!nextStep && formInvalid)}
          onClick={onSubmit}>
          {submitLabel}
        </button>
      </div>
    )
  }
}
